import $ from "jquery";
import axios from "axios";
// import Swal from 'sweetalert2'
// import * as Globals from 'globals'

var log = console.log;

axios.defaults.withCredentials = true

function onClick(element,callback){
	$(document).on('click',element,callback);
}

function onChange(element,callback){
	$(document).on('change',element,callback);
}

function prepareSessUrl(url) {

	let sessId = localStorage.getItem('impsessionid');
	let token = localStorage.getItem('imptoken');
	// let salt = localStorage.getItem('impsalt');
	
	axios.defaults.headers.common = {
		'Authorization': `Bearer ${sessId}`,
		'sess_id': sessId
	}
	return url;
}

function Get(url,successCallback,errorCallback,finallyCallback){
	// url = prepareSessUrl(url);
	let query = axios.get(url)
	setCallbacks( query, successCallback, errorCallback, finallyCallback)
}

function GetJson(url,successCallback,errorCallback,finallyCallback){
	// url = prepareSessUrl(url);
	let query = axios.get(url, {
		responseType: 'json'
	})
  setCallbacks( query, successCallback, errorCallback, finallyCallback)
}

function Post(url,data,successCallback, errorCallback, finallyCallback){
	url = prepareSessUrl(url);
	let query = axios.post(url, data)
  setCallbacks( query, successCallback, errorCallback, finallyCallback)
}

function PostJson(url ,data, successCallback, errorCallback, finallyCallback){
	url = prepareSessUrl(url);
  if (typeof data == 'object') {
    data = Object.keys(data).map(key => key + '=' + data[key]).join('&');
  }
	let query = axios.post(url, data, {
		responseType: 'json'
	})
  setCallbacks( query, successCallback, errorCallback, finallyCallback)
}

function PostFileJson(url ,data, successCallback, errorCallback, finallyCallback){
	url = prepareSessUrl(url);
  // if (typeof data == 'object') {
  //   data = Object.keys(data).map(key => key + '=' + data[key]).join('&');
  // }
  let query = axios({
    method: "POST",
    url: url,
    data: data,
    responseType: 'json',
    headers: {
      'Content-Type': 'multipart/form-data; boundary=${form._boundary}'
    }
  })

  setCallbacks( query, successCallback, errorCallback, finallyCallback)
}

let setCallbacks = ( query, successCallback, errorCallback, finallyCallback) => {
	if (typeof successCallback != 'undefined') {
		query.then((data) => {
      let d = data.data;
      if (d.authError) {
        if(window.location != '/login' && window.location != '/login/'){
          Auth(() => {
            window.location = "";
          }, () => {
            window.location = "/login";
          });
        }
      } else {
        successCallback(d);
      }
		});
	}

  query.catch((err)=>{
    console.log(err);
    if (typeof errorCallback != 'undefined') {
      errorCallback(err);
    }
  });
	
	if (typeof finallyCallback != 'undefined') {
		query.then(finallyCallback);
	}
}

function _Done(txt,title,callback) {
	alertDone(title,txt,callback)
}
	
function alertDone(title,text,callback){
	
	if(typeof title == 'undefined'){
		title = 'Успешно';
	}
	if(typeof text == 'undefined'){
		text = '';
	}
	
	let sw = Swal.fire({
	  title: title,
	  html: text,
	  type: "success"
	})
	if(typeof callback != 'undefined') {
		sw.then((result) => {
			callback(result)
		})
	}
}

function _Error(txt,title,callback) {
	alertError(title,txt,callback)
}

function alertError(title,text,callback){
	if(typeof title == 'undefined'){
		title = 'Ошибка';
	}
	if(typeof text == 'undefined'){
		text = '';
	}
	let sw = Swal.fire({
	  title: title,
	  html: text,
	  confirmButtonText: 'Закрыть',
	  type: "error"
	});
	if(typeof callback != 'undefined') {
		sw.then((result) => {
			callback(result)
		})
	}
	
}

function moneyFormat(value,options) {
  const defaultOptions = {
    significantDigits: 0,
    thousandsSeparator: ' ',
    decimalSeparator: '.',
    symbol: ''
  }
  if (typeof value !== 'number') value = 0.0
  options = { ...defaultOptions, ...options }
  value = value.toFixed(options.significantDigits)

  const [currency, decimal] = value.split('.')
  return `${options.symbol} ${currency.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    options.thousandsSeparator
  )}`
  // ${options.decimalSeparator}${decimal}
}

var $tmp_buffer;

function startLoader($obj){
	var $jobj = $($obj);
	return activateLoader($jobj);
}

function endLoader($obj){
	var $jobj = $($obj);
	return deactiveLoader($jobj);
}

function activateLoader($obj){
	var $btn = $obj;
	$btn.prop('disabled',true);
	$tmp_buffer = $btn.html();
	$btn.html('<div class="loader"><div class="dot-floating"></div></div>');
}

function deactiveLoader(obj){
	var $btn = $(obj);
	$btn.html($tmp_buffer);
	$btn.prop('disabled',false);
}

let deviceId = (setDeviceId) => {
  if (typeof device != 'undefined') {
    if (device.uuid) {
      return device.uuid;
    }
  }
  if (setDeviceId) {
    return setDeviceId;
  }
  let device_id = localStorage.getItem('impd');
  if (device_id) {
    return device_id;
  }
  let genId = uuidv4();
  localStorage.setItem('impd',genId);
  return genId;
}

let Auth = (successCallback, errorCallback) => {
  let sessId = localStorage.getItem('impsessionid');
  if (sessId) {
    GetJson(window.iOptions.API_URL + '/auth/', (data) => {
      if (data.status == 1) {
        successCallback(data);
      } else {
        AuthByToken(successCallback, errorCallback)
      }
    });
  } else {
    let token = localStorage.getItem('imptoken');
    let salt = localStorage.getItem('impsalt');
    if (token && salt) {
      AuthByToken(successCallback, errorCallback)
    }
  }
}

let AuthByToken = (successCallback,errorCallback) => {
  let token = localStorage.getItem('imptoken');
  let salt = localStorage.getItem('impsalt');
  let device_id = deviceId();
  if (token && salt) {
    PostJson(window.iOptions.API_URL + '/auth/resession/', {
      token: token,
      salt: salt,
      d: device_id,
    }, (data) => {
      if (data.status == 1) {
        successCallback(data);
      } else {
        localStorage.removeItem("impsessionid");
        localStorage.removeItem("imptoken");
        localStorage.removeItem("impsalt");

        errorCallback(data);
      }
    });
  } else {
    errorCallback(data);
  }
}

export default {
	log: log,
	onClick: onClick,
	onChange: onChange,
	Get: Get,
	Post: Post,
	GetJson: GetJson,
	PostJson: PostJson,
	PostFileJson: PostFileJson,
	Error: _Error,
	Done: _Done,
	startLoader: startLoader,
	endLoader: endLoader,
	moneyFormat: moneyFormat,
}